/**
 * Permissions des routes
 */

// version du BO
export const VERSION_BO = '2.0.17'

// selon le role de l'utilisateur
export const ALL_ACCESS = ['peon', 'agent', 'super', 'admin', 'adminTF'] // acces à tous le monde
export const NO_PEONS = ['agent', 'super', 'admin', 'adminTF'] // tous sauf peons
export const NO_AGENTS = ['peon', 'super', 'admin', 'adminTF'] // tous sauf agents
export const NO_ADMINS = ['peon', 'agent', 'super', 'adminTF'] // tous sauf admin
export const NO_PEONS_NOR_AGENTS = ['super', 'admin', 'adminTF'] // tous sauf peons et agents
export const NO_PEONS_NO_AGENTS_NO_SUPER = ['admin', 'adminTF'] // tous sauf peons, agents et admin
export const NO_PEONS_NO_AGENTS_NO_ADMINS_NO_SUPER = ['adminTF'] // tous sauf peons, agents, admin et super
export const NO_PEONS_NO_AGENTS_NO_ADMINS = ['super', 'adminTF'] // tous sauf peons, agents et admin
export const NO_PEONS_NO_ADMINS = ['agent', 'super', 'adminTF'] // tous sauf peons et admin

// selon le level de la licence
export const LEVEL = {
  HS: 0,
  ESSAI: 1,
  CHAT: 10,
  START: 5,
  PRO: 6,
  ENTREPRISE: 7,
  FAQ: 8
}

export const AWSS3_STATIC = 'https://targetfirst.s3.fr-par.scw.cloud' // fichiers static
export const AWSS3_PUBLIC = 'https://box-targetfirst.s3.fr-par.scw.cloud' // fichiers public
export const AWSS3_RAG_BOX = 'https://rag-box.s3.fr-par.scw.cloud' // fichiers pour le rag

export const DOMAINE = window.location.origin
export const PUBLIC = 'https://public.targetfirst.com'
export const CLOUD = 'https://cloud.targetfirst.com'
export const HOTESSES_DIR = DOMAINE + ((process.env.NODE_ENV === 'production') ? '/' : '/') + '/public/media/img/hotesses/'
export const RECALL_DIR = DOMAINE + ((process.env.NODE_ENV === 'production') ? '/' : '/') + 'media/img/icones/'

export const FORM_LAYOUT = [
  { show: true, title: 'currentPage', icon: 'http' },
  { show: true, title: 'lastLoadingDate', icon: 'history' },
  { show: true, title: 'autochatTitle', icon: 'beenhere' },
  { show: true, title: 'comment', icon: 'comment' },
  { show: true, title: 'identity', icon: 'perm_identity' },
  { show: true, title: 'email', icon: 'mail' },
  { show: true, title: 'phone', icon: 'phone' },
  { show: true, title: 'location', icon: 'room' },
  { show: true, title: 'browser', icon: 'devices' },
  { show: true, title: 'language', icon: 'language' },
  { show: true, title: 'IP', icon: 'device_hub' },
  { show: true, title: 'leadHeat', icon: 'whatshot' },
  { show: true, title: 'alertCart', icon: 'add_shopping_cart' },
  { show: true, title: 'lastInvitAuto', icon: 'local_offer' },
  { show: true, title: 'beginningChat', icon: 'textsms' },
  { show: true, title: 'navigationHistory', icon: 'list' },
  { show: true, title: 'purchases', icon: 'shopping_cart' },
  { show: true, title: 'lastKnownBasket', icon: 'credit_card' },
  { show: true, title: 'motif', icon: 'contact_support' },
  { show: true, title: 'gclid', icon: 'sensor_occupied' }
]

// Motifs connus en fonction de la licence
export const MOTIFS_ORPI = [
  { text: 'A. Infos biens', value: 'A' },
  { text: 'B. LEAD - RDV Tel (1 agence)', value: 'B' },
  { text: 'C. LEAD - RDV Tel (2 agence)', value: 'C' },
  { text: 'D. LEAD - Mail (1 agence)', value: 'D' },
  { text: 'E. LEAD - Mail (2 agence)', value: 'E' },
  { text: 'F. LEAD - Visite (1 agence)', value: 'F' },
  { text: 'G. LEAD - Visite (2 agence)', value: 'G' },
  { text: 'H. LEAD - Projet de vente (1 agence)', value: 'H' },
  { text: 'I. LEAD - Projet de vente (2 agence)', value: 'I' },
  { text: 'J. LEAD - Projet de vente et RDV Tel', value: 'J' },
  { text: 'K. LEAD - Projet de vente et Visite', value: 'K' },
  { text: 'L. LEAD AUTRE (Mandat en cours, Syndic, Gestion locative...SA...', value: 'L' },
  { text: 'M. LEAD KO - Mail non renseigné', value: 'M' },
  { text: 'N. Réclamation', value: 'N' },
  { text: 'O. Dysfonctionnement site/outils', value: 'O' },
  { text: 'P. Autres (A UTILISER EXCEPTIONNELLEMENT)', value: 'P' }
]
// Motifs connus en fonction de la licence
export const MOTIFS_NUXE = [
  { text: 'Informations produits', value: '2' },
  { text: 'Diagnostic', value: '128' },
  { text: 'Informations soins SPA', value: '172' },
  { text: 'Aide à la commande SPA', value: '50' },
  { text: 'Informations Offres commerciales', value: '33' },
  { text: 'Informations Livraison', value: '32' },
  { text: 'Aide à la commande e commerce produits', value: '4' },
  { text: 'Suivi de commande e commerce', value: '31' },
  { text: 'Réclamations E commerce', value: '36' },
  { text: 'Informations Programme de fidélité', value: '6' },
  { text: 'Réclamations Programme de fidélité', value: '29' },
  { text: 'Demande d\'échantillons', value: '9' },
  { text: 'Autres', value: '8' }
]// Motifs connus en fonction de la licence
export const MOTIFS_INOYA = [
  { text: 'Informations sur la marque et les produits', value: '1' },
  { text: 'Informations Commandes', value: '2' },
  { text: 'Demande d\'échantillons', value: '3' },
  { text: 'Programme Fidélité', value: '4' },
  { text: 'Réclamations', value: '5' },
  { text: 'Demandes Marketing', value: '6' },
  { text: 'Demandes RH', value: '7' },
  { text: 'Ou trouver vos produits', value: '8' },
  { text: 'Suivi de ma commande', value: '14' },
  { text: 'Convertir Points Oya', value: '22' },
  { text: 'Efficacité du protocole de soins', value: '28' },
  { text: 'Partenariat Blog ou Réseaux Sociaux', value: '34' },
  { text: 'Protocole de soins', value: '10' },
  { text: 'Difficulté à passer ma commande', value: '15' },
  { text: 'Envoi récompense carte de fidélité', value: '23' },
  { text: 'Problèmes sur mon colis commandé', value: '33' },
  { text: 'Demande de distribution commerciale', value: '35' },
  { text: 'Questions sur les prix', value: '11' },
  { text: 'Délais de livraison', value: '16' },
  { text: 'Demande de carte de fidélité', value: '24' },
  { text: 'Réclamations Aspect, texture et odeur', value: '29' },
  { text: 'Jeux concours', value: '36' },
  { text: 'Composition et Conservation des Produits', value: '12' },
  { text: 'Fidélité Mixte : Points OYA et Carte de fidélité', value: '26' },
  { text: 'Réaction allergique', value: '30' },
  { text: 'Sollicitations Commerciales Extérieures', value: '37' },
  { text: 'Conseils sur des produits non vendus par IN\'OYA', value: '13' },
  { text: 'Informations Paiement', value: '21' },
  { text: 'Suggestions et Axes d\'amélioration', value: '27' },
  { text: 'Demande de remboursement', value: '31' },
  { text: 'Distributeurs IN\'OYA', value: '38' },
  { text: 'Codes Promo et Avantages particuliers', value: '25' },
  { text: 'Désinscription Bases de données IN\'OYA', value: '32' },
  { text: 'Changement statut commande dans le Back Office', value: '39' }
]

export const PERIODS = [1, 2, 3, 4]
export const PERIODS_START = [1, 2]
export const PERIODS_PRO = [1, 2, 3]
export const PERIODS_ENTREPRISE = [1, 2, 3, 4]



// WEBPACK FOOTER //
// ./src/constants.js